export enum CandidateDetailsTab {
  Summary = 'summary',
  Resume = 'resume',
  Interview = 'interview',
  Notes = 'notes'
}
